import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectItem, ConfirmationService } from 'primeng/api';
import * as _ from 'lodash';
import { BusinessDepartmentService } from './../../business-department.services';
import { DeviationServices } from '../../deviation/services/deviation.service';
import { JobAnalysisService } from '../../safety-job-analysis/services/jobanalysis.services';
import { BusinessServices } from './../../businesses/services/business.services';

import { BaseServices } from './../../kuba.services';
import { ValidationService } from 'src/app/kuba/shared/services/validation.service';
import { RiskanalysisService } from '../services/risk-analysis.service';
import { SafetyBaseComponent } from '../../safety-job-analysis/components/safety-base.component';
import {
  MailInformation,
  RiskAnalysisCategoryDropdown,
  RiskAnalysisCategoryColor,
  RiskAnalysisListDto,
  RISK_ANALYSIS_CATEGORY_DROPDOWN_LIST_LIVE,
  RISK_ANALYSIS_CATEGORY_DROPDOWN_LIST_STAGING
} from './../models/riskanalysis';
import { Department } from '../models/riskanalysis';
import { Rights, FeatureKey } from 'src/app/_models';
import { FeatureBase } from 'src/app/kuba/features/models/features-base.model';
import { TranslateService } from '@ngx-translate/core';
import { Table } from 'primeng/table';
import { Select } from 'primeng/select';
import { environment } from 'src/environments/environment.prod';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HttpContext } from '@angular/common/http';
import { SKIP_ERROR_TOAST } from 'src/app/shared/http-context-tokens';
import { FilterService } from 'primeng/api';
import { DomSanitizer } from '@angular/platform-browser';
import { HelperService } from 'src/app/_services/helper.service';

type DropdownValueChangeEvent<T = unknown> = {
  value: T | null;
  originalEvent?: Event;
};

type RiskTableFilterType =
  | 'department'
  | 'topic'
  | 'sorting'
  | 'risk'
  | 'category'
  | 'approvalStatus';

type RiskTableFilterConfig = {
  field: string;
  matchMode: 'arrayIncludes' | 'contains' | 'equals';
};

@Component({
  selector: 'followups-riskanalysis',
  templateUrl: 'riskanalysis-list.component.html',
  styleUrls: ['riskanalysis-list.component.css'],
  standalone: false
})
export class RiskAnalysisListComponent
  extends SafetyBaseComponent
  implements OnInit
{
  // #region variable
  @ViewChild('riskTable', { static: false }) riskTable: Table;
  private readonly notifications = inject(NotificationService);

  // filters
  @ViewChild('departmentDropdown', { static: false })
  departmentDropdown: Select;
  @ViewChild('sortingDropdown', { static: false })
  sortingFilterDropdown: Select;
  @ViewChild('cd', { static: false }) categoryDropdown: Select;
  @ViewChild('topicFilterInput', { static: false })
  topicFilterInput: ElementRef<HTMLInputElement>;
  @ViewChild('riskDropdown', { static: false }) riskDropdown: Select;
  @ViewChild('approvalDropdown', { static: false }) approvalDropdown: Select;
  @ViewChild('locationFilterInput', { static: false })
  locationFilterInput: ElementRef<HTMLInputElement>;
  @ViewChild('titleFilterInput', { static: false })
  titleFilterInput: ElementRef<HTMLInputElement>;
  @ViewChild('descriptionFilterInput', { static: false })
  descriptionFilterInput: ElementRef<HTMLInputElement>;

  isAddNewRisk = false;
  IsGenerateReport = true;
  IsApproveButton: boolean;
  featureBase: FeatureBase;
  isSorting = true;
  riskDetails: RiskAnalysisListDto[] = [];
  showNotification: boolean;
  selectedRisks: RiskAnalysisListDto[] = [];
  approvalNotices: any = [];
  riskAnalysisDepartment: FormGroup;
  riskDepartmentDropDown: FormGroup;
  departments: SelectItem[];
  Topics: SelectItem[];
  editDepartments: any = [];
  // collapse button
  rowID: number = null!;
  isCollapsed = false;
  addType = false;
  viewType = false;
  departmentId: number;
  Sorting: SelectItem[];
  isAdministrateRiskAnalysis = true;
  isDisableDeleteIcon = true;
  isAdmin: boolean;
  isPortal: boolean;
  Status: SelectItem[];
  Business: SelectItem[];
  departmentExisting: string;
  existsAlerttext: string;
  isdepartmentExists = false;
  isNameExists = false;
  isGuest: boolean;
  Riskdata: any;
  featureId: number;
  isOnlyAdmin: boolean;
  loading: boolean;
  selectedBusinessId: number;
  IsSendEmail: boolean = false;
  loadingMail: boolean = false;
  IncidentList: any = [];
  CategoryList: any = [];
  showActionPlan: boolean;
  showRiskScheme: boolean;
  ActionPlanList = [];
  allIncidents: any = [];
  totalIncidents: number;
  StatusIcon: string;
  sendMail = true;
  isfunctionExists: boolean;
  riskForm: FormGroup;
  riskFormData: any;
  roleId: any;
  Category: RiskAnalysisCategoryDropdown[];
  private subscriptions: Subscription[] = [];
  showNewBtn: boolean;
  isEditAccess = false;
  riskDatas: any;
  riskAnalysisData: any;
  sorting: SelectItem[];
  Approval: any[];
  loadingReport = false;
  fileName: string;
  selectedRiskId: number;
  ReportJson: any;
  selectedRisksCount: number;
  displayDialog: boolean = false;
  showStaticData: boolean = false;
  isRmode: boolean = BaseServices.IsRmode;
  isFlexi: boolean = false;
  showPreview: boolean = false;
  previewUrl: any;
  isPreviewMode: boolean = false;

  /**
   * Gets the default risk categories based on the environment.
   */
  private get defaultRiskCategories(): RiskAnalysisCategoryDropdown[] {
    return environment.BASE_FRONT_URL === 'https://ik.kuba.no/'
      ? RISK_ANALYSIS_CATEGORY_DROPDOWN_LIST_LIVE
      : RISK_ANALYSIS_CATEGORY_DROPDOWN_LIST_STAGING;
  }

  /**
   * Maps each logical filter key to the PrimeNG table field and match mode used
   * when applying or clearing filters from the risk table UI.
   */
  private readonly riskTableFilterConfig: Record<
    RiskTableFilterType,
    RiskTableFilterConfig
  > = {
    department: {
      field: 'BusinessDepartmentId',
      matchMode: 'arrayIncludes'
    },
    topic: {
      field: 'TopicId',
      matchMode: 'equals'
    },
    sorting: {
      field: 'Sorting',
      matchMode: 'equals'
    },
    risk: {
      field: 'RiskFigureData.ValueText',
      matchMode: 'contains'
    },
    category: {
      field: 'CategoryId',
      matchMode: 'equals'
    },
    approvalStatus: {
      field: 'ApprovalStatus',
      matchMode: 'equals'
    }
  };

  //#endregion

  // #region constructor

  /**
   * constructor
   * @param riskanalysisService {RiskanalysisService}
   * @param jobAnalysisService{JobAnalysisService}
   * @param route {ActivatedRoute}
   * @param router {Router}
   * @param _fb {FormBuilder}
   * @param confirmationService {ConfirmationService}
   */
  constructor(
    private riskanalysisService: RiskanalysisService,
    private route: ActivatedRoute,
    public router: Router,
    private _fb: FormBuilder,
    public confirmationService: ConfirmationService,
    private businessService: BusinessServices,
    private businessDepartmentService: BusinessDepartmentService,
    private translate: TranslateService,
    private deviationService: DeviationServices,
    private safetyjobservice: JobAnalysisService,
    private filterService: FilterService,
    private sanitizer: DomSanitizer
  ) {
    super();
    this.riskAnalysisDepartment = this._fb.group({
      department: [
        '',
        [Validators.required, ValidationService.noWhitespaceValidator]
      ]
    });
    this.riskDepartmentDropDown = this._fb.group({
      department: ['']
    });
  }

  //#endregion

  // #region page-event

  /**
   * bind risk analysis list
   */
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.roleId = BaseServices.roleId;
    const workingModule = sessionStorage.getItem('workingModule');
    if (workingModule && JSON.parse(workingModule).name === 'Flexi') {
      this.isFlexi = true;
    }
    this.riskForm = this._fb.group({
      CategoryId: [],
      Title: [],
      Location: [],
      TopicId: [],
      DepartmentId: [],
      ExpectedBehaviour: [],
      RelatedIncident: [],
      Alreadyactiontaken: [],
      Probability: [],
      Consequence: [],
      RiskFigure: [],
      Participants: [],
      IsActive: [],
      Sorting: [],
      CreatedOn: [],
      ModifiedOn: []
    });
    this.showNewBtn = BaseServices.roleId === '1' ? false : true;
    this.isAdmin = BaseServices.roleId === '1' ? true : false;
    this.isGuest = BaseServices.roleId === '4' ? true : false;
    this.isPortal = BaseServices.roleId === '2' ? true : false;
    this.isOnlyAdmin = BaseServices.roleId === '1' ? true : false;
    switch (BaseServices.UserRole) {
      case 'Admin':
        this.IsGenerateReport = false;
        this.isAddNewRisk = false;
        this.IsApproveButton = true;
        this.IsSendEmail = false;
        break;
      case 'Editor':
        this.IsGenerateReport = true;
        this.isAddNewRisk = false;
        this.IsApproveButton = false;
        this.riskDetails = this.route.snapshot.data['list'];
        this.IsSendEmail = true;
        this.getStatusUnApproved(this.riskDetails);
        break;
      case 'User':
        this.IsGenerateReport = true;
        this.isAddNewRisk = false;
        this.IsApproveButton = false;
        this.riskDetails = this.route.snapshot.data['list'];
        let currentUserRole = BaseServices.UserRole;
        let userRightsId = Rights.ADMINISTRATE_RISK_ANALYSIS;
        this.IsSendEmail = BaseServices.checkUserRights(
          userRightsId,
          currentUserRole
        );
        this.getStatusUnApproved(this.riskDetails);
        break;
      case 'Guest':
        this.IsGenerateReport = false;
        this.isAddNewRisk = false;
        this.IsApproveButton = false;
        this.riskDetails = this.route.snapshot.data['list'];
        break;
      case 'Portal':
        this.IsGenerateReport = false;
        this.isAddNewRisk = true;
        this.IsApproveButton = true;
        this.riskDetails = this.route.snapshot.data['Risklist'];
        break;
    }
    document.querySelector('body').classList.remove('opened');

    //kW-1279
    if (this.riskDetails.length > 0) {
      let data = this.riskDetails.filter(x => x.SentMail == false);
      if (data.length > 0) {
        this.sendMail = true;
      } else {
        this.sendMail = false;
      }
    }

    if (window.name === 'Remote') {
      this.subscriptions.push(
        this.businessService.getById(BaseServices.BusinessId).subscribe(res => {
          let featureRights = [];
          featureRights = JSON.parse(res.Features);
          let features = [];
          features = featureRights;
          if (features) {
            features.forEach((feature: any) => {
              if (feature.id === FeatureKey.FOLLOW_UP) {
                let childrens = feature.children;
                childrens.forEach((children: any) => {
                  if (
                    children.id ===
                      FeatureKey.RISK_ANALYSIS_EXTRA_SORTINGFIELD &&
                    children.checked
                  ) {
                    this.isSorting = false;
                  }
                });
              }
            });
          }
        })
      );
    } else {
      this.featureBase = BaseServices.getUserFeatures();
      let features = [];
      features = JSON.parse(this.featureBase.Features);
      if (features) {
        features.forEach((feature: any) => {
          if (feature.id === FeatureKey.FOLLOW_UP) {
            let childrens = feature.children;
            childrens.forEach((children: any) => {
              if (
                children.id === FeatureKey.RISK_ANALYSIS_EXTRA_SORTINGFIELD &&
                children.checked
              ) {
                this.isSorting = false;
              } else {
                this.isSorting = true;
              }
            });
          }
        });
      }
    }

    if (BaseServices.UserRole === 'User') {
      this.isDisableDeleteIcon = false;
      this.onAdministrateRiskAnalysis();
    } else if (BaseServices.UserRole !== 'Editor') {
      this.isAdministrateRiskAnalysis = false;
    }
    this.approvalNotices = this.route.snapshot.data['approvalNotices'];
    this.departments = [];
    this.editDepartments = [];
    let department = this.route.snapshot.data['departments'];
    if (department) {
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          this.departments = [];
          this.departments.push({ label: val.SELECT, value: null });
          department.forEach((departmentCheck: any) => {
            if (departmentCheck) {
              this.departments.push({
                label: departmentCheck.Name,
                value: departmentCheck.Id
              });
              this.editDepartments.push({
                Name: departmentCheck.Name,
                Id: departmentCheck.Id
              });
            }
          });
        })
      );
    }
    // Topics
    this.Topics = [];
    let topics = [];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.Topics.push({ label: val.SELECT, value: null });
      })
    );
    if (BaseServices.roleId === '1') {
      topics = this.route.snapshot.data['adminTopic'];
    } else {
      topics = this.route.snapshot.data['topic'];
    }
    if (topics) {
      topics.forEach((topicsList: any) => {
        this.Topics.push({
          label: topicsList.Name,
          value: topicsList.Id
        });
      });
    }
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.Sorting = [];
        this.Sorting.push({ label: val.SELECT, value: null });
        this.Sorting.push({ label: 'Person', value: 'Person' });
        this.Sorting.push({ label: 'Miljø', value: 'Miljø' });
        this.Sorting.push({ label: 'Materiell', value: 'Materiell' });
      })
    );
    this.subscriptions.push(
      this.translate.stream('SELECT_STATUS_DROP').subscribe(val => {
        this.Status = [];
        this.Status.push(
          { label: val.SELECT, value: null },
          { label: val.INACTIVE, value: 0 },
          { label: val.ACTIVE, value: 1 }
        );
      })
    );

    this.subscriptions.push(
      this.translate.stream('RISKFIGURE_DROPDOWN').subscribe(val => {
        this.Riskdata = [];
        this.Riskdata.push(
          { label: val.SELECT, value: null },
          { label: val.LOW, value: 'Low' },
          { label: val.MEDIUM, value: 'Medium' },
          { label: val.HIGH, value: 'High' }
        );
      })
    );
    this.subscriptions.push(
      this.translate.stream('APPROVAL').subscribe(val => {
        this.Approval = [];
        this.Approval.push(
          { label: val.SELECT, value: null },
          { label: val.APPROVE, value: 'Approved' },
          { label: val.UNAPPROVED, value: 'Unapproved' }
        );
      })
    );

    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.Business = [];
        this.Business.push({ label: val.SELECT, value: null });
      })
    );

    let businessList = this.route.snapshot.data['business'];
    if (businessList) {
      businessList.forEach((repitition: any) => {
        if (repitition.Features != null) {
          var feature = JSON.parse(repitition.Features);
          var checkFollowup = feature.find(x => x.id == 15);
          if (
            checkFollowup != null &&
            checkFollowup != undefined &&
            checkFollowup.checked
          ) {
            this.Business.push({
              label: repitition.Name,
              value: repitition.Id
            });
          }
        }
      });
    }
    if (!this.isAdmin && !this.isPortal) {
      this.bindRiskDetails();
    }
    if (this.roleId == '2') {
      this.riskDetails = [];
      this.allIncidents = [];
      this.selectedBusinessId = JSON.parse(
        sessionStorage.getItem('CurrentBusinessId')
      );

      if (this.selectedBusinessId > 0) {
        this.subscriptions.push(
          this.riskanalysisService
            .portalList(this.selectedBusinessId)
            .subscribe(result => {
              if (result) {
                this.riskDetails = result;
                this.GetCategorizedRiskDetails();
              }
            })
        );
      } else {
        this.riskDetails = this.route.snapshot.data['Risklist'];
        if (this.riskDetails != null) {
          this.GetCategorizedRiskDetails();
        }
      }
      this.riskDepartmentDropDown.controls['businessId'].setValue(
        this.selectedBusinessId
      );
    }

    let customCategories: any;
    this.Category = [];
    const defaultCategories =
      this.defaultRiskCategories.map<RiskAnalysisCategoryDropdown>(
        category => ({
          label: `SELECT_FOR_CATEGORY.${category.label}`,
          value: category.value,
          isDefault: category.isDefault,
          color: category.color
        })
      );

    this.Category = [...defaultCategories];

    customCategories = this.route.snapshot.data['category'];
    if (customCategories) {
      customCategories.forEach((category: any) => {
        this.Category.push({
          label: category.Name,
          value: category.Id,
          isDefault: false,
          color: RiskAnalysisCategoryColor.Custom
        });
      });
    }

    if (this.roleId == '2') {
      this.isEditAccess =
        this.roleId == '2' && this.selectedBusinessId > 0 ? true : false;
    } else {
      this.isEditAccess = this.roleId == '3' ? true : false;
    }
    this.bindDepartmentDropdown();
    this.sortingDropdown();

    this.filterService.register(
      'translatedContains',
      (value: any, filter: any): boolean => {
        // 1. Safety checks for empty filter/value
        if (filter === undefined || filter === null || filter.trim() === '') {
          return true;
        }
        if (value === undefined || value === null) {
          return false;
        }
        // We convert to string and remove characters like { } < > used in templates/HTML
        const safeKey = String(value).replace(/[{}\[\]<>\/]/g, '');

        // 3. Translate the sanitized key
        const translatedValue = this.translate.instant(safeKey);

        // 4. Compare
        return translatedValue.toLowerCase().includes(filter.toLowerCase());
      }
    );

    this.filterService.register(
      'arrayIncludes',
      (
        value: number[] | null | undefined,
        filter: number | string | null | undefined
      ): boolean => {
        if (filter === undefined || filter === null || filter === '') {
          return true;
        }

        if (!Array.isArray(value)) {
          return false;
        }

        return value.includes(Number(filter));
      }
    );
  }

  /**
   * Gets the label for a default risk category based on its ID.
   * @param categoryId Identifier of the category to get the label for.
   * @param fallbackLabel Label to return if the category is not found.
   * (Usually used to display user-added custom category names that are not in the default list)
   * @returns The label for the specified category or the fallback label.
   */
  getRiskCategoryLabel(categoryId?: number, fallbackLabel = ''): string {
    if (!categoryId) {
      return 'Ukategorisert';
    }

    const defaultCategory = this.defaultRiskCategories.find(
      category => category.value === Number(categoryId)
    );

    if (defaultCategory?.label) {
      return `SELECT_FOR_CATEGORY.${defaultCategory.label}`;
    }

    return fallbackLabel || 'Ukategorisert';
  }

  /**
   * Category label exactly as the list renders it. Default categories resolve to a
   * translation key, custom ones are already plain text and must be left alone.
   */
  private getTranslatedRiskCategoryLabel(
    categoryId?: number,
    fallbackLabel = ''
  ): string {
    const label = this.getRiskCategoryLabel(categoryId, fallbackLabel);
    return label.startsWith('SELECT_FOR_CATEGORY.')
      ? this.translate.instant(label)
      : label;
  }

  //#endregion

  // #region methods

  /**
   * bind department dropdown
   */
  bindDepartmentDropdown() {
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.departments = [];
        this.departments.push({ label: val.SELECT, value: null });
      })
    );
    this.subscriptions.push(
      this.businessDepartmentService
        .getCachedBusinessDepartment()
        .subscribe(departmentList => {
          if (departmentList) {
            this.editDepartments = [];
            departmentList.forEach((deptDropDown: any) => {
              if (deptDropDown) {
                this.departments.push({
                  label: deptDropDown.Name,
                  value: deptDropDown.Id
                });
                this.editDepartments.push({
                  Name: deptDropDown.Name,
                  Id: deptDropDown.Id
                });
              }
            });
          }
        })
    );
  }

  bindRiskDetails() {
    this.allIncidents = [];
    const businessId = BaseServices.BusinessId;
    if (businessId > 0) {
      this.subscriptions.push(
        this.riskanalysisService.list().subscribe(result => {
          if (result) {
            this.riskDetails = result;
            this.selectedRisks = [];
            this.GetCategorizedRiskDetails();
            if (this.allIncidents != null) {
              this.riskDatas = this.allIncidents;
            }
          }
        })
      );
    } else {
      this.GetCategorizedRiskDetails();
      if (this.allIncidents != null) {
        this.riskDatas = this.allIncidents;
      }
    }
  }

  //Get Category name from Id : KW-907
  GetCategoryNamefromID(CategoryId) {
    let Id = parseInt(CategoryId);
    if (CategoryId === '0') {
      return 'Ukategorisert';
    }
    // Look up from the translated Category dropdown first (covers hardcoded categories)
    if (this.Category) {
      const found = this.Category.find((x: any) => x.value === Id);
      if (found) {
        return found.label;
      }
    }
    // Fall back to CategoryList for user-added custom categories
    if (this.CategoryList) {
      const item = this.CategoryList.find((x: any) => x.Id === Id);
      if (item) return item.Name;
    }
    return 'Ukategorisert';
  }

  /**
   * Resolves the configured color for a risk category from the category dropdown list.
   *
   * @param categoryId Category identifier from the risk item.
   * @returns Hex color string for the category, or the default category color.
   */
  getCategoryColor(categoryId: number): string {
    const category = this.Category?.find((x: any) => x.value === categoryId);
    return category?.color || RiskAnalysisCategoryColor.Default;
  }

  /**
   * Builds the inline badge styles for a risk category using its configured color.
   *
   * @param categoryId Category identifier from the risk item.
   * @returns Style object with the tinted background and darkened text color.
   */
  getCategoryBadgeStyle(categoryId: number): {
    [key: string]: string;
  } {
    const color = this.getCategoryColor(categoryId);

    return {
      'background-color': this.hexToRgba(color, 0.18),
      color: this.darkenHexColor(color, 0.5)
    };
  }

  /**
   * Converts a hex color into an rgba value while preserving the original hue.
   *
   * @param hex Hex color in `#RRGGBB` format.
   * @param alpha Alpha value for the rgba output.
   * @returns Rgba color string, or the original input if the hex format is invalid.
   */
  private hexToRgba(hex: string, alpha: number): string {
    const normalizedHex = hex.replace('#', '');

    if (normalizedHex.length !== 6) {
      return hex;
    }

    const r = parseInt(normalizedHex.substring(0, 2), 16);
    const g = parseInt(normalizedHex.substring(2, 4), 16);
    const b = parseInt(normalizedHex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  /**
   * Darkens a hex color by reducing each RGB channel by the provided amount.
   *
   * @param hex Hex color in `#RRGGBB` format.
   * @param amount Decimal percentage used to darken the color.
   * @returns Darkened hex color, or the original input if the hex format is invalid.
   */
  private darkenHexColor(hex: string, amount: number): string {
    const normalizedHex = hex.replace('#', '');

    if (normalizedHex.length !== 6) {
      return hex;
    }

    const adjustChannel = (startIndex: number) => {
      const channel = parseInt(
        normalizedHex.substring(startIndex, startIndex + 2),
        16
      );
      return Math.max(0, Math.round(channel * (1 - amount)));
    };

    const r = adjustChannel(0).toString(16).padStart(2, '0');
    const g = adjustChannel(2).toString(16).padStart(2, '0');
    const b = adjustChannel(4).toString(16).padStart(2, '0');

    return `#${r}${g}${b}`;
  }

  //To get Categorized Risk Details : KW-907
  GetCategorizedRiskDetails() {
    if (this.riskDetails != null) {
      var riskDetails = this.riskDetails;
      var categorizedRisks = [];
      let catList: any = [];
      var groups = [];

      categorizedRisks = riskDetails.filter((x: any) => x.CategoryId != 0);
      groups = categorizedRisks.reduce(function (obj: any, item: any) {
        obj[item.CategoryId] = obj[item.CategoryId] || [];
        obj[item.CategoryId].push(item.Category);
        catList.push({ Id: item.CategoryId, Name: item.Category });
        return obj;
      }, Object.create(null));
      this.CategoryList = catList;

      var keys = [];
      keys = Object.keys(groups);
      keys.push('0'); // Add to get uncategorized

      var incidentCount: number = 0;
      keys.forEach((element: any) => {
        this.IncidentList = [];
        let incident = [];
        incident = this.riskDetails.filter(
          (x: any) => x.CategoryId == parseInt(element) && x.Title != null
        );
        incident.forEach((item: any) => {
          var IsDuplicate = false;
          //Check for duplicate Incidents
          let groupByStatus: any = [];
          item.TaskPlanListDto.forEach(function (a: any) {
            groupByStatus.push({ Id: a.Id, StatusText: a.StatusText });
          });
          this.StatusIcon = 'null';
          if (groupByStatus.length > 0) {
            let isDoneStatus = groupByStatus.every(function (x: any) {
              return x.StatusText == 'DONE';
            });
            if (isDoneStatus == true) {
              this.StatusIcon = 'icon ic-sm icon-clear-deadline';
            } else if (isDoneStatus == false) {
              this.StatusIcon = 'icon ic-sm icon-far-deadline';
            }
          }
          item.StatusIcon = this.StatusIcon;
          if (this.IncidentList != null) {
            let data = [];
            data = this.IncidentList;
            if (data.find((x: any) => x.Id === item.Id)) {
              IsDuplicate = true;
            }
            if (!IsDuplicate) {
              this.IncidentList.push({
                Id: item.Id,
                Category: item.Category,
                CategoryId: item.CategoryId,
                Title: item.Title,
                Location: item.Location,
                Topics: item.Topics,
                Description: item.Description,
                PotentialConsequence: item.PotentialConsequence,
                Alreadyactiontaken: item.Alreadyactiontaken,
                CreatedOn: item.CreatedOn,
                ModifiedOn: item.ModifiedOn,
                ModifiedBy: item.EditedBy,
                ApprovalStatus: item.ApprovalStatus,
                BackColor: item.RiskFigureData.BackColor,
                Value: item.RiskFigureData.Value,
                ValueText: item.RiskFigureData.ValueText,
                StatusIcon:
                  this.StatusIcon != undefined ? this.StatusIcon : 'null',
                ActionPlan: item.TaskPlanListDto,
                RiskFigure: item.RiskFigure,
                RiskFigureValue: item.RiskFigureData.Value,
                RelatedIncident: item.RelatedIncident,
                Partcipants: item.Partcipants,
                TaskPlanListDto: item.TaskPlanListDto,
                BusinessDepartmentId: item.BusinessDepartmentId,
                TopicId: item.TopicId,
                Sorting: item.Sorting
              });
              incidentCount = incidentCount + 1;
            }
          }
        });
        if (element != 'null') {
          this.allIncidents.push({
            CategoryId: element,
            Category:
              element != '0'
                ? this.GetCategoryNamefromID(element)
                : 'Ukategorisert',
            IncidentList: this.IncidentList
          });
        }
      });
      this.totalIncidents = incidentCount;
      this.allIncidents = this.allIncidents.sort((a, b) => {
        var nameA; // ignore upper and lowercase
        var nameB;
        if (a.Category != null) {
          nameA = a.Category.toUpperCase();
        }
        if (b.Category != null) {
          nameB = b.Category.toUpperCase();
        } // ignore upper and lowercase .toUpperCase()
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
      this.riskAnalysisData = this.allIncidents;
      const incidentLists = this.allIncidents.map(
        item => item.IncidentList.length
      );
      this.selectedRisksCount = incidentLists;
    }
  }

  public setCollapse(i: number): boolean {
    let isCollapsed = i === this.rowID;
    return !isCollapsed;
  }

  //#endregion

  // #region control-events

  /**
   * edit department
   * @param DeptType {any}
   */
  editDeptType(DeptType: Department) {
    this.departmentId = DeptType.Id!;
    let result = {
      department: DeptType.Name
    };
    (<FormGroup>this.riskAnalysisDepartment).setValue(result, {
      onlySelf: true
    });
  }

  /**
   * delete department
   * @param selectedDept {any}
   */
  deleteDept(selectedDept: any) {
    this.subscriptions.push(
      this.deviationService
        .checkDepartmentExist(selectedDept)
        .subscribe((result: any) => {
          if (result) {
            this.isdepartmentExists = true;
            this.departmentExisting = this.translate.instant(
              'CANT_DELETE_DEPARTMENT_USED_BY_ANOTHER_RA'
            );
            setTimeout(() => {
              this.isfunctionExists = false;
            }, 3000);
          } else {
            this.confirmationService.confirm({
              message: this.translate.instant('DELETE_THIS_RECORD'),
              accept: () => {
                this.subscriptions.push(
                  this.riskanalysisService
                    .deleteDepartement(selectedDept.Id)
                    .subscribe(isDepartmentDeleted => {
                      if (isDepartmentDeleted) {
                        this.notifications.success('UI_NOTIFICATIONS.DELETED');
                        this.clearCachedDepartment();
                        this.bindDepartmentDropdown();
                      }
                    })
                );
              }
            });
          }
        })
    );
  }

  showDialog() {
    this.displayDialog = true;
    this.isPreviewMode = false;
  }

  /**
   * export pdf
   */
  generateReport1(withApprovalStatus: boolean, isPreview: boolean = false) {
    this.displayDialog = false;
    let selectedRisks = this.selectedRisks;
    this.selectedRisks = [];
    selectedRisks.forEach((element: any) => {
      if (element.IncidentList) {
        element.IncidentList.forEach((data: any) => {
          this.selectedRisks.push(data);
        });
      } else {
        this.selectedRisks.push(element);
      }
    });

    const ids = this.selectedRisks.map((o: any) => o.Id); // report duplication issue fix
    const filteredList = this.selectedRisks.filter(
      ({ Id }: any, index: any) => !ids.includes(Id, index + 1)
    );

    if (this.selectedRisks.length > 0) {
      this.loading = true;
      let fileName = this.translate.instant('RISK_ANALYSIS');
      let type = 'pdf';
      let cultureInfo = 'en-GB';
      let languageMode = sessionStorage.getItem('languageMode');
      if (languageMode != null) {
        cultureInfo = languageMode;
      }
      // Default categories are named by a translation key on the client, so resolve the
      // label here and send it along -- otherwise the report falls back to the raw
      // CategoryName column and shows e.g. "Brann" where the list shows
      // "Brann- og eksplosjonsfare".
      let ReportJson = filteredList.map((risk: any) => ({
        ...risk,
        CategoryName: this.getTranslatedRiskCategoryLabel(
          risk.CategoryId,
          risk.Category
        )
      }));
      const handleResponse = (blob: Blob) => {
        if (blob.size === 0 || blob.type !== 'application/pdf') {
          this.notifications.error('UI_NOTIFICATIONS.EXPORT_FAILED');
          return;
        }
        const blobUrl = window.URL.createObjectURL(blob);
        if (isPreview) {
          // PREVIEW
          this.isPreviewMode = true;
          this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            blobUrl + '#view=FitH'
          );

          this.showPreview = true;
        } else {
          // DOWNLOAD
          let link = document.createElement('a');
          link.href = blobUrl;
          link.download = `${fileName}.${type.toLowerCase()}`;
          link.click();
        }
      };
      const handleError = () => {
        this.notifications.error('UI_NOTIFICATIONS.EXPORT_FAILED');
      };

      const businessId = BaseServices.UserRole === 'Portal'
        ? this.selectedBusinessId
        : BaseServices.BusinessId;
      this.subscriptions.push(
        this.safetyjobservice
          .reportGenerate(
            businessId,
            false,
            BaseServices.UserId,
            0,
            // The API selects the risk report and approvals by the Follow-ups ID,
            // including when the same risk list is opened from Flexi.
            FeatureKey.FOLLOW_UP,
            cultureInfo,
            ReportJson,
            BaseServices.ApplicationId,
            withApprovalStatus,
            new HttpContext().set(SKIP_ERROR_TOAST, true)
          )
          .pipe(finalize(() => { this.loading = false; }))
          .subscribe(handleResponse, handleError)
      );
    } else {
      this.loading = false;
      const alertKey = isPreview
        ? 'PLEASE_SELECT_A_REPORT_TO_PREVIEW'
        : 'PLEASE_SELECT_A_REPORT';
      this.notifications.warn(alertKey);
    }
  }

  /**
   * save department
   */
  saveDept() {
    let riskDept = new Department();
    riskDept.Id = this.departmentId ? this.departmentId : 0;
    riskDept.Name = this.riskAnalysisDepartment.value.department;
    riskDept.Status = '1';
    riskDept.BusinessId = BaseServices.BusinessId;
    riskDept.ApplicationId = BaseServices.ApplicationId;
    if (riskDept.Id > 0) {
      this.subscriptions.push(
        this.riskanalysisService
          .updateDept(riskDept)
          .subscribe((isDeptUpdated: any) => {
            if (isDeptUpdated) {
              this.clearCachedDepartment();
              this.bindDepartmentDropdown();
              this.riskDepartmentDropDown
                .get('department')!
                .patchValue(isDeptUpdated.Id);
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
            } else {
              this.clearCachedDepartment();
              this.existsAlerttext = this.translate.instant(`TOPIC_EXIST`);
              this.isNameExists = true;
              setTimeout(() => {
                this.isNameExists = false;
              }, 3000);
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.riskanalysisService
          .createDept(riskDept)
          .subscribe((isDeptAdded: any) => {
            if (isDeptAdded) {
              this.bindDepartmentDropdown();
              this.riskDepartmentDropDown
                .get('department')!
                .patchValue(isDeptAdded.Id);
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
            } else {
              this.existsAlerttext = this.translate.instant(`TOPIC_EXIST`);
              this.isNameExists = true;
              setTimeout(() => {
                this.isNameExists = false;
              }, 3000);
            }
          })
      );
    }
  }

  /**
   * cache clear of department
   */
  clearCachedDepartment() {
    this.businessDepartmentService.clearCachedAllDepartment();
  }

  onBusinessChanged(event: any, businessDropdown: any) {
    this.loading = true;
    if (event.value) {
      this.selectedBusinessId = event.value;
      sessionStorage.setItem('CurrentBusinessId', event.value);
      this.IsApproveButton = true;
      if (BaseServices.UserRole == 'Portal') {
        this.subscriptions.push(
          this.riskanalysisService
            .portalList(this.selectedBusinessId)
            .subscribe(result => {
              if (result) {
                this.riskDetails = null;
                this.allIncidents = [];
                this.riskDetails = result;
                this.loading = false;
                this.GetCategorizedRiskDetails();
              }
            })
        );
      } else {
        this.subscriptions.push(
          this.riskanalysisService
            .getRiskAnalysisForAdmin(BaseServices.ApplicationId, event.value)
            .subscribe(result => {
              if (result) {
                this.riskDetails = null;
                this.allIncidents = [];
                this.riskDetails = result;
                this.loading = false;
                this.GetCategorizedRiskDetails();
              }
            })
        );
      }
    } else {
      this.riskDetails = this.route.snapshot.data['Risklist'];
      this.loading = false;
      this.GetCategorizedRiskDetails();
    }
  }

  /**
   * Applies or clears a single table filter based on the selected dropdown value.
   *
   * When the dropdown is cleared, only the matching field filter is removed so
   * any other active table filters remain intact.
   *
   * @param event PrimeNG dropdown change payload containing the selected value.
   * @param filterType Logical filter key used to resolve the table field and match mode.
   */
  onFilterValueChanged(
    event: DropdownValueChangeEvent<number | string>,
    filterType: RiskTableFilterType
  ) {
    const filterConfig = this.riskTableFilterConfig[filterType];

    if (
      event.value === undefined ||
      event.value === null ||
      event.value === ''
    ) {
      this.riskTable.filter(null, filterConfig.field, filterConfig.matchMode);
      return;
    }

    this.riskTable.filter(
      event.value,
      filterConfig.field,
      filterConfig.matchMode
    );
  }

  /**
   * Clears the full table filter state and resets the visible filter controls.
   *
   * This keeps the PrimeNG table filters and the dropdown/input UI in sync after
   * the user chooses to reset all filters.
   */
  resetFilters() {
    this.riskTable.reset();
    this.clearDropdown(this.departmentDropdown);
    this.clearDropdown(this.sortingFilterDropdown);
    this.clearDropdown(this.categoryDropdown);
    this.clearInput(this.topicFilterInput);
    this.clearDropdown(this.riskDropdown);
    this.clearDropdown(this.approvalDropdown);
    this.clearInput(this.locationFilterInput);
    this.clearInput(this.titleFilterInput);
    this.clearInput(this.descriptionFilterInput);
  }

  /**
   * Resets a dropdown selection and its internal search text, if present.
   *
   * @param dropdown Dropdown instance bound to one of the table filter controls.
   */
  private clearDropdown(dropdown?: Select) {
    if (!dropdown) {
      return;
    }

    dropdown.writeValue(null);
    dropdown.resetFilter();
  }

  /**
   * Clears the visible value of a text-based filter input.
   *
   * @param input ElementRef for the filter input that should be blanked out.
   */
  private clearInput(input?: ElementRef<HTMLInputElement>) {
    if (!input?.nativeElement) {
      return;
    }

    input.nativeElement.value = '';
  }

  /**
   * department popup reset
   */
  onBeforeRiskDepartmentDialogHide() {
    this.riskAnalysisDepartment.reset();
  }

  toggleClick(i: number): void {
    this.rowID = i;
    this.isCollapsed = !this.isCollapsed;
  }

  toggleClickHide(): void {
    this.rowID = null!;
  }

  /**
   * delete risk
   * @param id {number}
   */
  confirm(id: number) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.riskanalysisService
            .deleteRisk(id)
            .subscribe((isRiskDeleted: any) => {
              if (isRiskDeleted) {
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
                if (this.riskDetails) {
                  this.riskDetails = this.riskDetails.filter(
                    (x: any) => x.Id !== id
                  );
                }
                this.allIncidents.forEach((data: any) => {
                  data.IncidentList = data.IncidentList.filter(
                    (x: any) => x.Id !== id
                  );
                });
              }
            })
        );
      }
    });
  }

  saveApprovalNotice() {
    this.loading = true;
    let approvalNotices: number[] = [];
    let selectedRisks = this.selectedRisks; //approve issue fix
    this.selectedRisks = [];
    selectedRisks.forEach(element => {
      this.selectedRisks.push(element);
    });

    if (this.selectedRisks.length > 0) {
      this.selectedRisks.forEach((e: any) => {
        approvalNotices.push(e.Id);
      });
    } else {
      this.showNotification = true;
    }
    this.subscriptions.push(
      this.riskanalysisService
        .addApprovalNotices(approvalNotices)
        .subscribe(addResult => {
          if (addResult) {
            this.notifications.success('UI_NOTIFICATIONS.APPROVAL_SENT');
            this.refreshNotificationTable();
          }
          this.subscriptions.push(
            this.riskanalysisService.list().subscribe(result => {
              if (result) {
                this.riskDetails = result;
                this.selectedRisks = [];
                this.allIncidents = [];

                var riskDetails = result;
                var categorizedRisks = [];
                let catList = [];
                var groups = [];

                categorizedRisks = riskDetails.filter(x => x.CategoryId != 0);
                groups = categorizedRisks.reduce(function (obj, item) {
                  obj[item.CategoryId] = obj[item.CategoryId] || [];
                  obj[item.CategoryId].push(item.Category);
                  catList.push({ Id: item.CategoryId, Name: item.Category });
                  return obj;
                }, Object.create(null));
                this.CategoryList = catList;

                var keys = [];
                keys = Object.keys(groups);
                keys.push('0'); // Add to get uncategorized

                var incidentCount: number = 0;
                keys.forEach((element: any) => {
                  this.IncidentList = [];
                  let incident = [];
                  incident = this.riskDetails.filter(
                    x => x.CategoryId == parseInt(element) && x.Title != null
                  );
                  incident.forEach((item: any) => {
                    var IsDuplicate = false;
                    //Check for duplicate Incidents
                    let groupByStatus = [];
                    item.TaskPlanListDto.forEach(function (a) {
                      groupByStatus.push({
                        Id: a.Id,
                        StatusText: a.StatusText
                      });
                    });
                    this.StatusIcon = 'null';
                    if (groupByStatus.length > 0) {
                      let isDoneStatus = groupByStatus.every(function (x: any) {
                        return x.StatusText == 'DONE';
                      });
                      if (isDoneStatus == true) {
                        this.StatusIcon = 'icon ic-sm icon-clear-deadline';
                      } else if (isDoneStatus == false) {
                        this.StatusIcon = 'icon ic-sm icon-far-deadline';
                      }
                    }
                    item.StatusIcon = this.StatusIcon;
                    if (this.IncidentList != null) {
                      let data = [];
                      data = this.IncidentList;
                      if (data.find(x => x.Id === item.Id)) {
                        IsDuplicate = true;
                      }
                      if (!IsDuplicate) {
                        this.IncidentList.push({
                          Id: item.Id,
                          Category: item.Category,
                          CategoryId: item.CategoryId,
                          Title: item.Title,
                          Location: item.Location,
                          Topics: item.Topics,
                          Description: item.Description,
                          PotentialConsequence: item.PotentialConsequence,
                          Alreadyactiontaken: item.Alreadyactiontaken,
                          CreatedOn: item.CreatedOn,
                          ModifiedOn: item.ModifiedOn,
                          ModifiedBy: item.EditedBy,
                          ApprovalStatus: item.ApprovalStatus,
                          BackColor: item.RiskFigureData.BackColor,
                          Value: item.RiskFigureData.Value,
                          ValueText: item.RiskFigureData.ValueText,
                          StatusIcon:
                            this.StatusIcon != undefined
                              ? this.StatusIcon
                              : 'null',
                          ActionPlan: item.TaskPlanListDto,
                          RiskFigure: item.RiskFigure,
                          RiskFigureValue: item.RiskFigureData.Value,
                          Partcipants: item.Partcipants,
                          TaskPlanListDto: item.TaskPlanListDto
                        });
                        incidentCount = incidentCount + 1;
                      }
                    }
                  });
                  if (element != 'null') {
                    this.allIncidents.push({
                      CategoryId: element,
                      Category:
                        element != '0'
                          ? this.GetCategoryNamefromID(element)
                          : 'Ukategorisert',
                      IncidentList: this.IncidentList
                    });
                  }
                });
                this.totalIncidents = incidentCount;
              }
              this.loading = false;
            })
          );
        })
    );
    this.notifications.success('UI_NOTIFICATIONS.SAVED');
  }

  refreshNotificationTable() {
    this.subscriptions.push(
      this.riskanalysisService
        .getApprovalNoticeByBusiness()
        .subscribe((notificationList: any) => {
          if (notificationList) {
            this.approvalNotices = notificationList;
          }
        })
    );
  }

  /**
   * disable new button based upon the rights
   */
  onAdministrateRiskAnalysis() {
    let userRightsId = Rights.ADMINISTRATE_RISK_ANALYSIS;
    let role = BaseServices.UserRole;
    if (role === 'User') {
      this.isAdministrateRiskAnalysis = BaseServices.checkUserRights(
        userRightsId,
        role
      );
    }
  }

  gotoNew() {
    sessionStorage.setItem('CurrentBusinessId', null);
    setTimeout(() => {
      this.router.navigate(['./newrisk'], {
        queryParams: {},
        relativeTo: this.route
      });
    }, 1000);
  }

  sendReportMail() {
    this.loadingMail = true;
    let CultureInfo = 'en-GB';
    let objMailInformation = new MailInformation();
    let Tomail = this.approvalNotices.map((x: any) => x.Id);
    let TomailName = this.approvalNotices.map((x: any) => x.Name);
    objMailInformation.ToMail = Tomail;
    objMailInformation.ToMailName = TomailName;
    objMailInformation.BusinessId = BaseServices.BusinessId;
    let languageMode = sessionStorage.getItem('languageMode');
    if (languageMode != null) {
      objMailInformation.CultureInfo = languageMode;
    }
    this.subscriptions.push(
      this.riskanalysisService
        .sendRiskMail(objMailInformation)
        .subscribe(success => {
          this.loadingMail = false;
          this.sendMail = false;
          this.notifications.success('MAIL_SUCCESS');
        })
    );
  }

  getStatusUnApproved(data) {
    if (this.IsSendEmail && data != null) {
      let IsUnApproved = [];
      IsUnApproved = data.filter((x: any) => x.ApprovalStatus == 'Unapproved');
      if (IsUnApproved.length > 0) {
        this.IsSendEmail = true;
      } else {
        this.IsSendEmail = false;
      }
    }
  }

  onPreviewClick() {
    this.isPreviewMode = true;
    this.displayDialog = true;
  }

  confirmGenerate(withStatus: boolean) {
    this.generateReport1(withStatus, this.isPreviewMode);
  }

  closePopUp() {
    this.showPreview = false;
    this.showActionPlan = false;
    this.isPreviewMode = false;
  }

  ActionPlanDialog(incidentID: number): void {
    this.showActionPlan = true;
    let data = [];
    data = this.riskDetails.filter((x: any) => x.Id == incidentID);
    this.ActionPlanList = [];
    let list: any = [];
    data.forEach((element: any) => {
      if (element.TaskPlanListDto != null) {
        list = element.TaskPlanListDto;
      }
    });
    this.ActionPlanList = list;
  }

  RiskSchemeDialog(incidentID: number) {
    this.showRiskScheme = true;
    this.Topics = [];
    this.selectedRiskId = incidentID;
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        let topics;
        this.Topics = [];
        this.Topics.push({ label: val.SELECT, value: null });
        if (this.roleId === 1) {
          topics = this.route.snapshot.data['adminTopic'];
        } else {
          topics = this.route.snapshot.data['topic'];
        }
        if (topics) {
          topics.forEach((topicsList: any) => {
            this.Topics.push({
              label: topicsList.Name,
              value: topicsList.Id
            });
          });
        }
      })
    );

    this.departments = [];
    this.editDepartments = [];
    let department;
    this.subscriptions.push(
      this.riskanalysisService
        .getDepartmentsForAdmin(incidentID)
        .subscribe(riskForm => {
          department = riskForm;
          if (department) {
            this.editDepartments = department;
            this.subscriptions.push(
              this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
                this.departments = [];
                department.forEach((departmentList: any) => {
                  this.departments.push({
                    label: departmentList.Name,
                    value: departmentList.Id
                  });
                });
              })
            );
          }
        })
    );

    this.subscriptions.push(
      this.riskanalysisService.getById(incidentID).subscribe(riskForm => {
        this.riskFormData = riskForm;
        let catId: Number = this.riskFormData.CategoryId;
        const resultCat: any = this.Category.find(cat_val => {
          return cat_val.value == this.riskFormData.CategoryId;
        });
        this.riskForm.get('Title').patchValue(this.riskFormData.Title);
        this.riskForm
          .get('CategoryId')
          .patchValue(this.translate.instant(resultCat.label));
        this.riskForm.get('Location').patchValue(this.riskFormData.Location);
        this.riskForm.get('TopicId').patchValue(this.riskFormData.TopicId);
        let departmentList = [];
        let checkDepartmentList = [];
        this.riskFormData.RiskAnalysisDepartment != null
          ? this.riskFormData.RiskAnalysisDepartment.forEach(element => {
              departmentList.push(element.RiskDepartmentId);
            })
          : this.riskFormData.DepartmentId;
        departmentList.forEach(element => {
          let checkValueDept = this.departments.filter(x => x.value == element);
          if (checkValueDept.length > 0) {
            checkDepartmentList.push(checkValueDept);
          }
        });
        if (checkDepartmentList.length == 0) {
          departmentList = [];
        }
        this.riskForm.get('DepartmentId').patchValue(departmentList);
        this.riskForm.get('Sorting').patchValue(this.riskFormData.Sorting);
        this.riskForm
          .get('ExpectedBehaviour')
          .patchValue(this.riskFormData.ExpectedBehaviour);
        this.riskForm
          .get('RelatedIncident')
          .patchValue(this.riskFormData.RelatedIncident);
        this.riskForm
          .get('Alreadyactiontaken')
          .patchValue(this.riskFormData.Alreadyactiontaken);
        this.riskForm
          .get('Probability')
          .patchValue(this.riskFormData.Probability);
        this.riskForm
          .get('Consequence')
          .patchValue(this.riskFormData.Consequence);
        this.riskForm
          .get('Participants')
          .patchValue(this.riskFormData.Partcipants);
        this.riskForm
          .get('CreatedOn')
          .patchValue(HelperService.formatDateTo(this.riskFormData.CreatedOn));
        this.riskForm
          .get('ModifiedOn')
          .patchValue(
            this.riskFormData.ModifiedOn
              ? HelperService.formatDateTo(this.riskFormData.ModifiedOn)
              : ''
          );
        let Probability = this.riskFormData.Probability;
        let Consequence = this.riskFormData.Consequence;
        this.setRiskFigure(Probability, Consequence);
      })
    );

    this.subscriptions.push(
      this.riskanalysisService.getById(this.selectedRiskId).subscribe(res => {
        this.ReportJson = res;
        this.featureId = this.ReportJson.FeatureKey;
      })
    );
  }

  exportPdf() {
    this.loadingReport = true;
    this.fileName = this.translate.instant('RISKANALYSIS_DETAILS');
    let fileType = 'pdf';
    let cultureInfo = sessionStorage.getItem('languageMode');
    this.subscriptions.push(
      this.riskanalysisService
        .riskAnalysisReportGenerate(
          BaseServices.BusinessId,
          this.selectedRiskId,
          cultureInfo,
          this.ReportJson,
          this.featureId,
          BaseServices.UserId,
          false
        )
        .subscribe(
          blob => {
            this.loadingReport = false;
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.fileName}.${fileType.toLowerCase()}`;
            link.click();
            this.showRiskScheme = false;
          },
          error => {
            this.loadingReport = false;
            
          }
        )
    );
  }

  sortingDropdown() {
    // Sorting
    this.subscriptions.push(
      this.translate.stream('SELECT_SORTING').subscribe(val => {
        this.sorting = [];
        this.sorting.push({ label: val.SELECT, value: null });
        this.sorting.push({ label: val.PERSON, value: val.PERSON });
        this.sorting.push({
          label: val.ENVIRONMENTAL,
          value: val.ENVIRONMENTAL
        });
        this.sorting.push({ label: val.MATERIAL, value: val.MATERIAL });
      })
    );
  }

  toggleStaticData() {
    this.showStaticData = !this.showStaticData;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}

//#endregion
